import { Model } from 'core/model';

/**
 * Represents a single NMS custom report (DeviceProfile Report proto).
 *
 * These models are backed by the `/api/ui/recon/customReports` REST handlers,
 * which normalize snake_case service payloads to camelCase JSON for the UI, so
 * fields map directly.
 */
export default class CustomReportModel extends Model {
  get urlRoot() {
    return '/api/ui/recon/customReports';
  }

  serialize(data) {
    return { report: super.serialize(data) };
  }

  deserialize(data) {
    return super.deserialize(data?.report ?? data);
  }
}
